<script lang="ts">
	import {onMount} from "svelte";

    export let value = '';

    onMount( () => {
        if( typeof value !== 'string' ){
            value = '';
		}
	})
</script>
<div class="acp-cf-value -contains">
	<input bind:value type="text">
</div>